import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { keyLoading, selectIcbs, selectLoading } from './store/slice'
import { getIcbThunk } from './store/thunk'

let cacheKey = null

const useGetIcb = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoading(keyLoading.ICB))
  const icbs = useSelector(selectIcbs)

  useEffect(() => {
    if (cacheKey !== locale) {
      cacheKey = locale
      dispatch(getIcbThunk())
    }
  }, [locale])

  return {
    loading,
    icbs,
  }
}

export default useGetIcb
